var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-cascader',{attrs:{"options":_vm.options,"load-data":_vm.loadData,"popupVisible":_vm.popupVisible,"placeholder":"Please select"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }